import { getPrivateApi } from "../lib/axiosConfig";
import { ActivateMachine, RemoveCamQueue } from "../types/machine.types";
import { AppError } from "./classes";
import { retry } from "./generic";

const api = getPrivateApi();
const endpoint = "/machine"
const stationsEndpoint = "/stations"

export const removeCamQueue = async (payload: RemoveCamQueue): Promise<void> => {
  try {
    await api.put(`${stationsEndpoint}/cam-queue/remove`, payload);
  } catch (error: any) {
    const errMsg = "Erro ao acionar máquina";

    console.error(errMsg, error?.response?.data || error.message || error);

    const message = error?.response?.data?.message ?? errMsg;

    throw new AppError(message, error.status);
  }
};

export const activateMachine = async (payload: ActivateMachine): Promise<void> => {
  try {
    const response = await retry(() =>
      api.post(`${endpoint}/publish`, payload), 3, 3000
    );
    console.log('Maquina ativada com sucesso!', response.data);
  } catch (error: any) {
    const errMsg = "Erro ao ativar maquina";

    console.error(errMsg, error?.response?.data || error.message || error);

    const message = error?.response?.data?.message ?? errMsg;

    throw new AppError(message, error.status);
  }
}
